/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEmergencyS = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M10 2h4v20h-4z" />
        <path d="m19.66 5.268 2 3.464-17.32 10-2-3.464z" />
        <path d="m2.34 8.732 2-3.464 17.32 10-2 3.464z" />
        <path d="m2.34 8.732 2-3.464 17.32 10-2 3.464z" />
      </g>
    </g>
  </Icon>
);
export { SvgEmergencyS as EmergencyS };
